






























































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IPermitVueModel } from '@/ts/models/IPermitVueModel';

@Component({
    props: {
        form: {
            type: Object as () => IPermitVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class ContactEmail extends Vue {

    name: string = "ContactEmail";
    title: string = "";
    index: number = NaN;
    formName: string = "";

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent(this.name);
        this.$props.form.permitName = this.$props.vueStates.formName;
        if (this.$props.vueStates.formName === "RockCrushingApplication") {
            this.formName = "Rock Crushing Application";
        } else if (this.$props.vueStates.formName === "CCDDApplication") {
            this.formName = "CCDD Application"
        }
        if (this.$props.vueStates.isRenewal == true) {
            this.$props.form.isRenewal = true;
        }
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    get isEmailError(): boolean {
        return func.isNullOrEmpty(this.$props.form.email) || !func.isValidEmail(this.$props.form.email);
    }

    get isEmailConfirmError(): boolean {
        return func.isNullOrEmpty(this.$props.form.emailConfirm) || (this.$props.form.email !== this.$props.form.emailConfirm);
    }

    get hasErrors(): boolean {
        return this.isEmailError || this.isEmailConfirmError;
    }

    get certDate(): string {
        let date = new Date(this.$props.form.certificationDate);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }
}

